<template>
  <!-- ABOUT US -->
  <section class="about-section" ref="aboutSection">
    <div class="about-inner" ref="aboutInner">
<h2 class="about-title" ref="aboutTitle">About Us</h2>
 <p class="about-text" ref="aboutText">
  At EA Magic Cleaning LLC, we believe that every client deserves a clean, healthy, and welcoming environment.
  <br> Our team of professionals is committed to providing reliable, high-quality cleaning services,
  always with great attention to detail.
</p>
<p class="about-exec" ref="aboutExec">Executive Director: <strong>Ivandra Menezes</strong></p>
 </div>
  </section>

  <!-- 🔻 YOUR EXACT SECTION, UNCHANGED, BELOW “ABOUT US” -->
  <section class="hero-split hero-split--separated" ref="seccion">
    <!-- Left image -->
    <div class="split-media" ref="imgWrap">
      <img
        class="split-img"
        :src="imagenSrc"
        :alt="imagenAlt"
        ref="imagen"
        fetchpriority="high"
      />
      <div class="media-fade"></div>
    </div>

    <!-- Right content -->
    <div class="split-content">
      <h2 class="split-title" ref="titulo">{{ titulo }}</h2>

      <p class="split-sub" ref="sub">
         Making your space shine like magic! ✨ <br />
        Professional cleaning services for houses, apartments, offices, churches, and more.
        <br />We take care of the cleaning so you can enjoy your time in a fresh and spotless space.
      </p>

      <!-- 🔹 Button -->
      <a class="split-cta" :href="ctaHref" target="_blank" rel="noopener" ref="btn">
        Book Cleaning
      </a>

      <!-- 🔹 New highlight block -->
      <div class="highlight" ref="highlight">
        <p>
          You can trust us to leave your home, office, or business in the hands of <strong>professional cleaners</strong>.
        </p>
      </div>
    </div>
  </section>
</template>
<script>
import { nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'SplitHeroSection',

props: {
  titulo:    { type: String, default: 'EA Magic Cleaning LLC' },
  imagenSrc: { type: String, default: () => require('@/assets/edificio.jpg') },
  imagenAlt: { type: String, default: 'Clean and tidy living room' },
  ctaHref: { 
    type: String, 
default: 'sms:+16122619287?&body=Hello, I\'m interested in information about Cleaning'
  }
  },

  data() {
    return {
      io: null,
      ctx: null,
      aboutIo: null,
      aboutCtx: null
    }
  },

  async mounted() {
    await nextTick()

    /* ---------- ABOUT: animación al entrar al viewport ---------- */
    const aboutSection = this.$refs.aboutSection
    const aboutTitle   = this.$refs.aboutTitle
    const aboutText    = this.$refs.aboutText
    const aboutExec    = this.$refs.aboutExec

    if (aboutSection) {
      this.aboutCtx = gsap.context(() => {
        gsap.set([aboutTitle, aboutText, aboutExec], { opacity: 0, y: 24 })
      }, aboutSection)

      this.aboutIo = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return
          const tlAbout = gsap.timeline()
          tlAbout
            .to(aboutTitle, { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' })
            .to(aboutText,  { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' }, '-=0.25')
            .to(aboutExec,  { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' }, '-=0.25')

          this.aboutIo.disconnect()
        })
      }, { threshold: 0.25 })

      this.aboutIo.observe(aboutSection)
    }

    /* ---------- HERO SPLIT: tu animación tal cual ---------- */
    const seccion   = this.$refs.seccion
    const imgWrap   = this.$refs.imgWrap
    const imagen    = this.$refs.imagen
    const tituloEl  = this.$refs.titulo
    const sub       = this.$refs.sub
    const btn       = this.$refs.btn
    const highlight = this.$refs.highlight

    if (!seccion) return

    this.ctx = gsap.context(() => {
      gsap.set(imgWrap, { clipPath: 'inset(0 100% 0 0)' })
      gsap.set(imagen, { scale: 1.08, y: 10, opacity: 0 })
      gsap.set([tituloEl, sub, btn, highlight], { opacity: 0, y: 30 })
    }, seccion)

    this.io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return

        const tl = gsap.timeline()
        tl.to(imgWrap, { clipPath: 'inset(0 0% 0 0)', duration: 0.7, ease: 'power3.out' })
          .to(imagen, { opacity: 1, scale: 1, y: 0, duration: 0.9, ease: 'power2.out' }, '-=0.4')
          .to(tituloEl, { opacity: 1, y: 0, duration: 0.45, ease: 'back.out(1.7)' }, '-=0.5')
          .to(sub, { opacity: 1, y: 0, duration: 0.45 }, '-=0.3')
          .to(btn, { opacity: 1, y: 0, duration: 0.45 }, '-=0.3')
          .to(highlight, { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out' }, '-=0.2')

        this.io.disconnect()
      })
    }, { threshold: 0.3 })

    this.io.observe(seccion)
  },

  beforeUnmount() {
    if (this.io) this.io.disconnect()
    if (this.ctx) this.ctx.revert()
    if (this.aboutIo) this.aboutIo.disconnect()
    if (this.aboutCtx) this.aboutCtx.revert()
  }
}
</script>


<style scoped>
/* ==== SOBRE NOSOTROS (solo estilos para el bloque superior) ==== */
.about-section {
  background: linear-gradient(135deg, #f8f9fb 0%, #ecf1f8 100%);
  padding: 48px 20px 32px;
}
.about-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 8px;
}
.about-title {
  margin: 0 0 10px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 900;
  font-size: clamp(28px, 5vw, 40px);
  color: #0e1a2f;
  letter-spacing: .3px;
}
.about-text {
  margin: 0 0 8px;
  color: #2a3550;
  font-size: 16px;
  line-height: 1.7;
}
.about-exec {
  margin: 6px 0 0;
  color: #2a3550;
  font-size: 16px;
}
.about-exec strong { font-weight: 800; color: #0e1a2f; }

/* ==== TU SECCIÓN EXACTA (NO MODIFICADA) ==== */
.hero-split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 76vh;
  background: #ffffff;
  overflow: hidden;
}
.hero-split--separated { margin-top: 48px; }

.split-media { position: relative; overflow: hidden; }
.split-img   { width: 100%; height: 100%; object-fit: cover; display: block; }
.media-fade  { position: absolute; top: 0; left: 0; right: 0; height: 80px;
               background: linear-gradient(to bottom, rgba(255,255,255,0.8), transparent); }

.split-content { display: flex; flex-direction: column; justify-content: center; padding: 48px 64px; }
.split-title   { font-family: 'Montserrat', sans-serif; font-weight: 800; font-size: 38px; color: #0e1a2f; margin-bottom: 16px; }
.split-sub     { font-size: 16px; line-height: 1.6; color: #13213a; margin-bottom: 20px; }

.split-cta {
  align-self: flex-start;
  background: #13213a;
  color: #fff;
  padding: 12px 20px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  border: 2px solid #f4c44d;
  transition: all 0.3s ease;
}
.split-cta:hover { background: #0f1b31; transform: translateY(-2px); }
.highlight {
  margin-top: 28px;
  background: #cbc56a;
  color: #ffffff;
  padding: 22px 28px;
  border-radius: 10px;
  font-size: 20px;        /* ⬅️ más grande */
  font-weight: 600;       /* ⬅️ semi-bold */
  line-height: 1.6;
  box-shadow: 0 6px 18px rgba(0,0,0,0.12);
  text-align: center;     /* ⬅️ centrado para más impacto */
}
.highlight strong {
  font-weight: 800;       /* ⬅️ aún más fuerte para destacar */
}

@media (max-width: 900px) {
  .hero-split { grid-template-columns: 1fr; }
  .split-content { padding: 32px 20px; text-align: center; align-items: center; }
  .split-cta { align-self: center; }
}
</style>
